<template>
  <div class="formCom">
    <div class="form" v-click-outside="closeModal">
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <div class="name">
        Add Admin
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input toLowerCase"
          placeholder="Email"
          v-model="form.email"
          @input="clearValidate"
          :class="{ invalid: errors.has('email_admin') }"
          name="email_admin"
          v-validate="'required|email'"
        />
        <span class="validate-error" v-if="errors.has('email_admin')">
          {{ errors.first("email_admin") }}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          placeholder="First Name"
          v-model="form.first_name"
          name="first_name_admin"
          :class="{ invalid: errors.has('first_name_admin') }"
          v-validate="'required|max:50'"
        />
        <span class="validate-error" v-if="errors.has('first_name_admin')">
          {{ errors.first("first_name_admin") }}
        </span>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          placeholder="Last Name"
          v-model="form.last_name"
          name="last_name_admin"
          :class="{ invalid: errors.has('last_name_admin') }"
          v-validate="'required|max:50'"
        />
        <span class="validate-error" v-if="errors.has('last_name_admin')">
          {{ errors.first("last_name_admin") }}
        </span>
      </div>
      <div class="input-wrap">
        <select
          class="input select"
          v-model="form.role"
          name="role"
          :class="{ invalid: errors.has('role') }"
          v-validate="'required'"
        >
          <option value="admin">Admin</option>
          <option value="superadmin">Superadmin</option>
        </select>
        <span class="validate-error" v-if="errors.has('last_name_admin')">
          {{ errors.first("last_name_admin") }}
        </span>
      </div>
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="AddNewAdmin"
      >
        Submit
      </button>
      <div class="txt">{{ txt }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import CloseIcone from "../../images/shared/cancel";

export default {
  name: "AddAdminModal",
  data() {
    return {
      form: {
        email: null,
        first_name: null,
        last_name: null,
        role: "admin"
      },
      txt: ""
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    clearValidate() {
      this.errors.clear();
      this.clearServerValidationErrors();
    },
    ...mapMutations(["clearServerValidationErrors"]),
    ...mapActions(["AddAdmin", "getAdminInfoList", "handleErrors"]),
    closeModal() {
      this.errors.clear();
      this.clearServerValidationErrors();
      this.$emit("closeAdminModal", false);
    },
    AddNewAdmin() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.AddAdmin(this.form)
        .then(res => {
          this.errors.clear();
          this.clearServerValidationErrors();
          this.txt = "Admin successfully added";
          this.getAdminInfoList("admins");
        })
        .catch(err => {
          this.handleErrors({
            errors: [
              {
                field: "email_admin",
                message: "This Email already registered"
              }
            ]
          });
        });
    }
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return this.form.email && this.form.first_name && this.form.last_name;
    }
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  }
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.input.invalid {
  border: 1px solid red;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 350px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.input-wrap {
  width: 100%;
  margin: 0 0 15px 0;
}
.input {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 15px 20px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: #98a4ae;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.select {
  height: 45px;
  background-color: #fff;
  color: #98a4ae;
  text-align-last: center;
}
.btn {
  background-color: #6cc24a;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #6cc24a;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #6cc24a;
}
.btn:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}
.btn.change:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid transparent;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.txt {
  color: green;
  font-size: 14px;
  margin: 15px 0 0px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
</style>
